// HOOKS
import useModal from "../../../../hooks/other/useModal.other.hook";
// COMPONENTS
import DefaultButton from "../../default.button";
import { ReactComponent as AddIcon } from "../../../../assets/icons/add.icon.svg";
import Modal from "../../../modals/modal.component";
import PermissionForm from "../../../forms/admin/users/permission.form";

const CreatePermissionsButton = ({ onClose = () => {} }) => {
  const { isShowing, open, close } = useModal();

  const handleOnClose = () => {
    onClose();
    close();
  };
  return (
    <>
      <Modal isOpen={isShowing} onClose={handleOnClose}>
        <div className="flex justify-evenly h-full w-full flex-row gap-6">
          <PermissionForm />
        </div>
      </Modal>
      <DefaultButton handleClick={open}>
        <AddIcon className="fill-white" />
        Create
      </DefaultButton>
    </>
  );
};

export default CreatePermissionsButton;
